import type { FoundationCondition } from "building-types/foundations/foundationEnums";
import type { FoundationSection, Slab } from "building-types/foundations/foundationTypes";
import { RoomClass } from "building-types/rooms/roomTypesEnum";
import { assertUnreachable } from "common/utils/assertUnreachable";
import {
  isBasementFoundationCondition,
  isBrickLedgeFoundationCondition,
  isDeckFoundationCondition,
  isGarageFoundationCondition,
  isInteriorFoundationCondition,
  isPerimeterFoundationCondition,
  isPorchFoundationCondition,
  isSpanFoundationCondition,
  isTransitionFoundationCondition,
} from "doc/utils/foundationSystemTools";
import * as THREE from "three";

export function foundationSectionMatColor(foundationSection: FoundationSection): THREE.Color {
  const {
    path: { condition },
  } = foundationSection;
  return foundationConditionMatColor(condition);
}

export function foundationConditionMatColor(condition: FoundationCondition): THREE.Color {
  let color = new THREE.Color(0, 0, 0);

  if (isInteriorFoundationCondition[condition] || isBasementFoundationCondition[condition]) {
    color.r = 1;
  } else if (isGarageFoundationCondition[condition]) {
    color.b = 1;
  } else if (isPorchFoundationCondition[condition] || isDeckFoundationCondition[condition]) {
    color.g = 1;
  }

  if (isPerimeterFoundationCondition[condition]) {
    // no change to color
  } else if (isSpanFoundationCondition[condition]) {
    color = color.offsetHSL(0.2, 0, 0);
  } else if (isTransitionFoundationCondition[condition]) {
    color = color.offsetHSL(-0.2, 0, 0);
  }

  if (isBrickLedgeFoundationCondition[condition]) {
    color = color.offsetHSL(0.1, 0, 0);
  }

  color = color.offsetHSL(0, -0.6, 0);
  return color;
}

export function slabMatColor(slab: Slab): THREE.Color {
  const { roomClass } = slab;
  let color = new THREE.Color(0, 0, 0);

  switch (roomClass) {
    case RoomClass.HOUSE:
    case RoomClass.GARAGE:
      color.b = 0.5;
      break;
    case RoomClass.PORCH:
    case RoomClass.DECK:
      color.g = 0.5;
      break;
    case RoomClass.PATIO:
      color.g = 0.7;
      color.r = 0.5;
      break;
    case RoomClass.BASEMENT:
      color.r = 0.5;
      color.g = 0.2;
    case RoomClass.EXTERIOR:
      break;
    default:
      assertUnreachable(roomClass);
  }

  color = color.offsetHSL(0, -0.6, 0);
  return color;
}
